/**
 * PetroPhoenix — demo second company to prove the white-label system.
 * The visible branding, logo and copy differ from GTES but all underlying
 * app functionality is identical.
 */
import logo from "../../assets/logos/petrophoenix/logo.svg";

const config = {
  slug: "petrophoenix",
  name: "PetroPhoenix Energy Pvt. Ltd.",
  shortName: "PetroPhoenix",
  tagline: "Upstream engineering & field services",
  website: "https://petrophoenix.com",
  domains: ["petrophoenix.com", "www.petrophoenix.com", "timesheet.petrophoenix.com"],

  brand: {
    primaryColor: "#F97316",     // phoenix orange
    secondaryColor: "#0F172A",   // deep slate
    accentColor: "#10B981",
    logo,
    favicon: logo,
  },

  contact: {
    email: "ops@petrophoenix.com",
    phone: "+971 4 000 0000",
    address: "DIFC, Dubai\nUnited Arab Emirates",
  },

  social: {
    linkedin: "https://www.linkedin.com/company/petrophoenix",
    twitter: "",
    facebook: "",
    instagram: "",
    youtube: "",
  },

  hero: {
    title: "Workforce operations for upstream energy teams",
    description:
      "Field attendance, rotational timesheets, project allocation and payroll — purpose-built for oil & gas crews.",
    primaryCta: "Sign in",
    secondaryCta: "Contact operations",
  },

  about: {
    headline: "About PetroPhoenix",
    body: "PetroPhoenix is an upstream engineering and field services company serving operators across the Middle East and East Africa.",
    bullets: [
      "Field offices in UAE, Oman and Egypt",
      "Rotational workforce management",
      "ISO 9001 / 14001 / 45001 certified",
    ],
  },

  services: [
    { title: "Field Engineering", description: "Mechanical & process engineering support on live sites." },
    { title: "Rotational Crew Management", description: "28/28 & 14/14 schedules with timesheet automation." },
    { title: "HSE Compliance", description: "Monitoring, audits and documentation to international standards." },
  ],

  testimonials: [],
  portfolio: [],

  seo: {
    title: "PetroPhoenix — Workforce Operations",
    description:
      "PetroPhoenix workforce operations platform for upstream energy — field attendance, rotational timesheets and payroll.",
    ogImage: "",
  },

  extras: {
    footerCopyright: "© {YEAR} PetroPhoenix Energy — Confidential",
  },
};

export default config;
